import React from 'react'
import { Timeline, Row, Col } from 'antd'
import '../../App.css'
import request from '../../utils/request';
import { dataFormat } from '../../utils';
import { useEffect } from 'react';
import { useState } from 'react';
import { prUrl, osintRequestAddress, oneSixSixRequestAddress } from '../config'

const PersonEvent =(props) => {
    console.log(props, 'props')
    const token = localStorage.getItem('token')
    const [eventList, setEventList] = useState([])
    const [url, setUrl] = useState('')
    const [isShowMaterial, setIsShowMaterial] = useState(false)
    const [materials, setMaterials] = useState([])
    const [active, setActive] = useState('')

    useEffect(() => {
        getEventsList()
    }, [props.id])

    const getEventsList = () => {
        request({
            // url: `${oneSixSixRequestAddress}/portrait/event/list?params%5bentityId%5d=${props.id}&params%5bentityType%5d=人物`,
            url: `${osintRequestAddress}/person/events?personid=${props.id}`,
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(res => {
            // setEventList(res.list)
            // setUrl(res.url)
            setEventList(res)
            setUrl(`http://103.59.148.166:8010/personEvent?id=${props.id}`)
        })
    }

    const viewRelatedMatetial = (event, index) => {
        const param = {
            aliasIds: event.participants.map((item) => item.id) + "",
            eventId: event.uuid,
            associate: 1,
            key: '',
            startTime: '',
            endTime: '',
            sourceType: '',
            trendLabel: '',
            ignore: 0,
            sortBy: '1',
            pageNum: 1,
            pageSize: 5
        }
        setActive(index)
		console.log(param);
        request({
            url: `${oneSixSixRequestAddress}/portrait/eventMaterialRef/selectEventCorrelate`,
            data: {
                ...param
            },
            headers: {
                'Authorization': token,
            },
            method: 'post',
        }).then(res => {
            // setEventList(res.list)
            console.log(res, 'reatetee')
            setIsShowMaterial(true)
            setMaterials(res.rows)
        })
    }

    return(
        <React.Fragment>
            <Row gutter={72}>
                <Col span={12}>
                    <a className="view-all-event" href={url} target="_blank">查看全部战略事件>></a>
                    {/* <span className="view-all-event">查看全部战略事件>></span> */}
                    <div className="person-event-timeline">
                        <Timeline>
                            {
                                eventList.slice(0,4).map((event, index) => (
                                    <Timeline.Item onClick={() => viewRelatedMatetial(event, index)} className={active === index ? 'active-item' : ''}>
                                        <div className="text-light">{`${event.occurrenceTime}, ${event.place}`}</div>
                                        <div className="text-weight">{event.content}</div>
                                        <div className="text-light">
                                            <span>{`【${event.labels}】`}</span>
                                            【
                                            <span>
                                                {event.participants.map((item) => (
                                                    item.name
                                                ))}
                                            </span>
                                            】
                                        </div>
                                    </Timeline.Item>
                                ))
                            }
                        </Timeline>
                    </div>                            
                </Col>
                {
                    isShowMaterial ? <Col className="materials-box" span={11}>
                        <div className="material-title">相关素材</div>
                        {
                            materials.map((item) => (
                                <div className="material-item">
                                    <a href={`${prUrl}${item.url}`} target="_blank" className="material-url">{item.url}</a>
                                    <div className="material-basic">时间：{dataFormat(item.publish_date)} 来源：{item.source_type}</div>
                                </div>
                                
                            ))
                        }
                    </Col> : ''
                }
            </Row>
        </React.Fragment>
    )
}

export default PersonEvent;